import { render, staticRenderFns } from "./GlyphInventory.vue?vue&type=template&id=cf494c5c&scoped=true&"
import script from "./GlyphInventory.vue?vue&type=script&lang=js&"
export * from "./GlyphInventory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf494c5c",
  null
  
)

export default component.exports